import { render, staticRenderFns } from "./ListaEmpresas.vue?vue&type=template&id=2602edd6&scoped=true&"
import script from "./ListaEmpresas.vue?vue&type=script&lang=js&"
export * from "./ListaEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602edd6",
  null
  
)

export default component.exports